<template>
	<div class="skyCheckboxPanel">
		<skySelectCard>
			<template slot="header">
				<span>{{ title }}</span>
				<el-link
					v-if="checked.length == list.length"
					@click="clear"
					type="primary"
					:underline="false"
					>取消
				</el-link>
				<el-link v-else @click="selectAll" type="primary" :underline="false">全选</el-link>
			</template>
			<el-checkbox-group v-model="checked" @change="select">
				<el-scrollbar>
					<el-checkbox
						v-for="item in list"
						:label="item[props.value]"
						:key="item[props.value]"
						:disabled="item.disabled && item.disabled()"
					>
						{{ item[props.label] }}
					</el-checkbox>
				</el-scrollbar>
			</el-checkbox-group>
		</skySelectCard>
		<skySelectCard>
			<template slot="header">
				<span>已选({{ checked.length }})</span>
				<el-link @click="clear" type="primary" :underline="false" :disabled="checked.length == 0"
					>清空
				</el-link>
			</template>
			<!-- <skyEmpty v-if="checked.length == 0" top="60px" /> -->
			<el-scrollbar>
				<skyAlert
					v-for="(item, index) in checked"
					:title="checkLabel(item)"
					:key="item"
					@close="deleteItem(index)"
				>
				</skyAlert>
			</el-scrollbar>
		</skySelectCard>
	</div>
</template>
<script>
import googleads from '@/backend/services/googleAds/googleAds.js';
import skySelectCard from './skySelectCard.vue';
import skyAlert from '../sky-alert.vue';

export default {
	name: 'skyCheckboxPanel',
	components: {
		skySelectCard,
		skyAlert
	},
	props: {
		value: {
			type: Array,
			default: function() {
				return [];
			}
		},
		title: {
			type: String,
			default: ''
		},
		code: {
			type: String,
			default: ''
		},
		dict: {
			type: String,
			default: '',
		},
		options: {
			type: Array,
			default: function() {
				return [];
			}
		},
		filterOptions: {
			type: Function,
			default: null
		},
		props: {
			type: Object,
			default: () => {
				return {
					label: 'name',
					value: 'code'
				};
			}
		}
	},
	watch: {
		dict: {
			handler: function (val) {
				if (val) {
					this.getDict(val);
				}
			},
			immediate: true,
		},
		code: {
			handler: function(val) {
				if (val) {
					this.getCode(val);
				}
			},
			immediate: true
		},
		options: {
			handler(val) {
				this.list = val;
			},
			immediate: true,
			deep: true
		},
		value: {
			handler(val) {
				this.checked = val;
			},
			immediate: true,
			deep: true
		}
	},
	data() {
		return {
			list: [],
			checked: []
		};
	},
	methods: {
		checkLabel(val) {
			let data = this.list.filter(item => item[this.props.value] == val);
			return data.length ? data[0][this.props.label] : '';
		},
		select(val) {
			this.checked = val;
			this.change();
		},
		selectAll() {
			if (this.filterOptions) {
				let result = [];
				this.list.forEach(item => {
					if (!item.disabled()) {
						result.push(item[this.props.value]);
					}
				});
				this.checked = result;
				this.change();
			} else {
				this.checked = this.list.map(item => {
					return item[this.props.value];
				});
				this.change();
			}
		},
		clear() {
			this.checked = [];
			this.change();
		},
		deleteItem(index) {
			this.checked.splice(index, 1);
			this.change();
		},
		change() {
			this.$emit('input', this.checked);
			this.$emit('change', this.checked);
		},
		async getCode(val) {
			let res = await googleads.codeFun(val);
			this.list = this.filterOptions ? this.filterOptions(res.data) : res.data;
		},
		async getDict(dict) {
			let res = await googleads.dictFun(dict);
			this.list = this.filterOptions ? this.filterOptions(res.data) : res.data;
		},
	}
};
</script>
<style lang="scss">
.skyCheckboxPanel {
	display: flex;

	.el-checkbox-group {
		padding-left: 18px;

		.el-checkbox {
			display: block;
		}
	}

	.el-scrollbar__wrap {
		height: 274px;
		margin-bottom: 0px !important;
	}
}
</style>
